import { render, staticRenderFns } from "./WhereToBuyItem.vue?vue&type=template&id=633230f4&scoped=true"
import script from "./WhereToBuyItem.vue?vue&type=script&lang=js"
export * from "./WhereToBuyItem.vue?vue&type=script&lang=js"
import style0 from "./WhereToBuyItem.vue?vue&type=style&index=0&id=633230f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633230f4",
  null
  
)

export default component.exports